<ng-content select="md-icon"></ng-content>
<span class="modus-option-text"><ng-content></ng-content></span>
@if (selected) {
  <md-icon>check</md-icon>
}
